var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mx_is)?_c('span',{staticClass:"opc-cart-item__value"},[_c('vloader',{attrs:{"loading":_vm.mx_loading,"value":_vm.portionAmount}})],1):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }